export default __webpack_public_path__ + "static/media/pointstar.5aa7f91e.svg";